import React from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import moment from "moment"
import { buildPreviewItems } from "./recorrencia-helpers"

const formatDate = d => d ? moment(d).format("DD/MM/YYYY") : ""
const formatCurrency = v => parseFloat(v || 0).toLocaleString("pt-br", { style: "currency", currency: "BRL" })

const FREQ_KEY = { S: "semanal", Q: "quinzenal", M: "mensal", B: "bimestral", T: "trimestral", E: "semestral", A: "anual" }
const REGRA_KEY = { M: "manter", A: "antecipar", P: "postergar" }

const PreviewConfirmacaoDialog = props => {
  const { t, isOpen, datas, valor, regra, onCancel, onConfirm, loading } = props

  const items = buildPreviewItems(datas, regra?.data_inicio, regra?.frequencia)
  const total = (datas || []).length * parseFloat(valor || 0)

  const freqLabel = regra?.frequencia ? t(`contaspagar.recorrencia.frequencia.${ FREQ_KEY[regra.frequencia] }`) : ""
  const regraLabel = regra?.regra_vencimento ? t(`contaspagar.recorrencia.regra_vencimento.${ REGRA_KEY[regra.regra_vencimento] }`) : ""

  return (
    <Modal isOpen={ isOpen } centered size="lg" backdrop="static">
      <ModalHeader>{ t("contaspagar.recorrencia.preview.titulo") }</ModalHeader>
      <ModalBody>
        <p>{ t("contaspagar.recorrencia.preview.intro", { n: (datas || []).length }) }</p>

        <div className="mb-3">
          <div>{ t("contaspagar.recorrencia.preview.frequencia", { valor: freqLabel }) }</div>
          <div>{ t("contaspagar.recorrencia.preview.inicio", { data: formatDate(regra?.data_inicio) }) }</div>
          { regra?.data_fim && <div>{ t("contaspagar.recorrencia.preview.termino", { data: formatDate(regra.data_fim) }) }</div> }
          <div>{ t("contaspagar.recorrencia.preview.regra_vencimento", { valor: regraLabel }) }</div>
        </div>

        <h6>{ t("contaspagar.recorrencia.preview.lista_titulo") }</h6>
        <div style={ { maxHeight: 300, overflowY: "auto", border: "1px solid #eee", padding: 10 } }>
          <ol className="mb-0">
            { items.map(item => (
              <li key={ item.indice }>
                { formatDate(item.data) } ({ moment(item.data).format("ddd") })
                { item.ajustada && (
                  <span className="text-warning ms-2">
                    ← { t("contaspagar.recorrencia.preview.ajustada") }
                  </span>
                ) }
              </li>
            )) }
          </ol>
        </div>

        <div className="mt-3">
          <strong>{ t("contaspagar.recorrencia.preview.valor_cada", { valor: formatCurrency(valor) }) }</strong>
          { " • " }
          <strong>{ t("contaspagar.recorrencia.preview.total", { valor: formatCurrency(total) }) }</strong>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={ onConfirm } disabled={ loading }>
          { t("contaspagar.recorrencia.preview.confirmar") }
        </Button>
        <Button color="secondary" onClick={ onCancel } disabled={ loading }>
          { t("contaspagar.recorrencia.preview.voltar") }
        </Button>
      </ModalFooter>
    </Modal>
  )
}

PreviewConfirmacaoDialog.propTypes = {
  isOpen: PropTypes.bool,
  datas: PropTypes.array,
  valor: PropTypes.any,
  regra: PropTypes.object,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  loading: PropTypes.bool,
}

export default withTranslation()(PreviewConfirmacaoDialog)
